module.exports = __webpack_public_path__ + "static/media/RUN.a95d4afe.svg";